export default __webpack_public_path__ + "static/media/personal01.682abf9f.mp4";